export function encodeDate(source: Date): string {
    return `${source.getFullYear()}-${source.getMonth() + 1}-${source.getDate()}`;
}
